import React from 'react';

import cl from 'classnames';

import Logo from '../../shared/Logo';
import { IHeaderProps } from '../../shared/types';
import { renderLeftContentDefault, renderLogoImage, renderRightContentDefault } from './functions';
import s from './index.module.css';

function Header({
  logo,
  companyName,
  preparedFor,
  title,
  travelDates,
  email,
  phone,
  border = true,
  renderLeftContent = renderLeftContentDefault,
  renderRightContent = renderRightContentDefault,
}: IHeaderProps) {
  return (
    <div className={cl({ [s.border]: border }, s.container)}>
      <div className={cl(s.flexItem, s.flexItemLeft)}>{renderLeftContent({ preparedFor, title, travelDates })}</div>

      <div className={cl(s.flexItem, s.flexItemCenter)}>
        <Logo logo={logo} companyName={companyName} renderImage={renderLogoImage} />
      </div>

      <div className={cl(s.flexItem, s.flexItemRight)}>{renderRightContent({ companyName, email, phone })}</div>
    </div>
  );
}

export default Header;
